import React from 'react';
import { Modal, Button } from './index';
import { AlertTriangle, CheckCircle, XCircle, Info } from 'lucide-react';

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirmar Acción',
  message = '¿Estás seguro de que quieres realizar esta acción?',
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  type = 'warning', // 'warning', 'danger', 'info', 'success'
  loading = false,
  confirmButtonVariant = 'default'
}) => {
  const getIcon = () => {
    switch (type) {
      case 'danger':
        return <XCircle className="w-6 h-6 text-red-600" />;
      case 'success':
        return <CheckCircle className="w-6 h-6 text-green-600" />;
      case 'info':
        return <Info className="w-6 h-6 text-blue-600" />;
      case 'warning':
      default:
        return <AlertTriangle className="w-6 h-6 text-amber-600" />;
    }
  };

  const getConfirmButtonStyle = () => {
    switch (type) {
      case 'danger':
        return 'bg-red-600 hover:bg-red-700 text-white';
      case 'success':
        return 'bg-green-600 hover:bg-green-700 text-white';
      case 'info':
        return 'bg-blue-600 hover:bg-blue-700 text-white';
      case 'warning':
      default:
        return 'bg-amber-600 hover:bg-amber-700 text-white';
    }
  };

  const handleConfirm = async () => {
    if (onConfirm) {
      await onConfirm();
    }
    onClose();
  };

  const handleCancel = () => {
    if (!loading) {
      onClose();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleCancel}
      title=""
      size="sm"
      closeOnOverlayClick={!loading}
      showCloseButton={false}
    >
      <div className="text-center p-6">
        {/* Icono */}
        <div className="flex justify-center mb-4">
          <div className="p-3 bg-gray-100 rounded-full">
            {getIcon()}
          </div>
        </div>

        {/* Título */}
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          {title}
        </h3>

        {/* Mensaje */}
        <p className="text-gray-600 mb-6">
          {message}
        </p>

        {/* Botones */}
        <div className="flex gap-3 justify-center">
          <Button
            onClick={handleCancel}
            variant="outline"
            disabled={loading}
            className="min-w-[100px]"
          >
            {cancelText}
          </Button>
          
          <Button
            onClick={handleConfirm}
            disabled={loading}
            className={`min-w-[100px] ${getConfirmButtonStyle()}`}
          >
            {loading ? (
              <>
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                Procesando...
              </>
            ) : (
              confirmText
            )}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal; 